import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Zap } from 'lucide-react';
import { mockTemplates } from '../mocks/automationData';
import { AppLogo } from '../components/AppLogo';
const styles = {
  btnPrimary: 'text-white rounded-md font-medium text-sm transition-all bg-[var(--brand-primary)] hover:bg-[var(--brand-primaryhover)] focus:outline-none focus:ring-2 focus:ring-[var(--brand-primaryring)]',
  card: 'bg-[var(--colors-background-card)] border border-[var(--colors-border-light)] rounded-lg shadow-[var(--shadows-sm)] hover:shadow-md transition-shadow flex flex-col',
  heading: 'text-[var(--colors-text-primary)] font-semibold',
  subtext: 'text-sm text-[var(--colors-text-tertiary)]'
};
export function AutomationTemplates() {
  const navigate = useNavigate();
  return <div className="max-w-7xl mx-auto p-6 space-y-6" data-id="element-3093">
      <div className="flex items-center gap-4" data-id="element-3094">
        <button onClick={() => navigate('/automations')} className="p-1.5 rounded-md hover:bg-[var(--colors-neutral-100)] text-[var(--colors-text-tertiary)] transition-colors" data-id="element-3095">
          <ArrowLeft className="w-5 h-5" data-id="element-3096" />
        </button>
        <div data-id="element-3097">
          <h1 className={`text-2xl ${styles.heading}`} data-id="element-3098">Templates</h1>
          <p className={`${styles.subtext} mt-1`} data-id="element-3099">
            Start quickly with pre-built recipes for common workflows.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3100">
        {mockTemplates.map(tpl => <div key={tpl.id} className={styles.card} data-id="element-3101">
            <div className="p-5 flex-1" data-id="element-3102">
              <div className="flex items-center gap-3 mb-4" data-id="element-3103">
                <AppLogo appId={tpl.triggerApp} size="lg" data-id="element-3104" />
                <ArrowRight className="w-5 h-5 text-[var(--colors-text-tertiary)]" data-id="element-3105" />
                <AppLogo appId={tpl.actionApp} size="lg" data-id="element-3106" />
                {tpl.popular && <span className="ml-auto text-[10px] uppercase tracking-wider font-bold bg-[var(--colors-info-light)] text-[var(--colors-info-dark)] px-2 py-1 rounded" data-id="element-3107">
                    Popular
                  </span>}
              </div>
              <h3 className="text-lg font-medium text-[var(--colors-text-primary)] mb-2" data-id="element-3108">
                {tpl.name}
              </h3>
              <p className="text-sm text-[var(--colors-text-secondary)] leading-relaxed" data-id="element-3109">
                {tpl.description}
              </p>
              <div className="mt-4 flex items-center gap-2 text-xs text-[var(--colors-text-tertiary)] font-mono" data-id="element-3110">
                <span data-id="element-3111">{tpl.triggerEvent}</span>
                <ArrowRight className="w-3 h-3" data-id="element-3112" />
                <span data-id="element-3113">{tpl.actionEvent}</span>
              </div>
            </div>
            <div className="p-4 border-t border-[var(--colors-border-light)] bg-[var(--colors-neutral-50)] rounded-b-lg" data-id="element-3114">
              <button onClick={() => navigate('/automations/new')} className={`${styles.btnPrimary} w-full py-2 flex items-center justify-center gap-2`} data-id="element-3115">
                <Zap className="w-4 h-4" data-id="element-3116" /> Use template
              </button>
            </div>
          </div>)}
      </div>
    </div>;
}